import { PayCode } from 'components/PayCodeSelectInput/PayCodeSelectInput.types';
import { TimeOffTitleEnum } from 'types/graphql';

export const filterPayCodesByTitle = (payCodes: PayCode[], title?: TimeOffTitleEnum): PayCode[] =>
  payCodes.filter((payCode) => payCode.time_off_title === title);
